import React from "react";
import colors from "../styles/colors";
import Button from "./Button";
import { useTranslation } from "react-i18next";

const AccessoryContainer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="w-full h-auto p-4 flex flex-col font-serif items-center justify-center mt-8"
      style={{ backgroundColor: colors.pastelCream }}
    >
      <h2
        className="lg:text-7xl text-3xl md:text-5xl text-center mb-4"
        style={{ color: colors.darkBrown }}
      >
        {t("accessoryContainer.title")}
      </h2>
      <p
        className="lg:text-2xl text-lg md:text-xl font-light text-center max-w-4xl mb-6"
        style={{ color: colors.darkBrown }}
      >
        {t("accessoryContainer.subTitle")}
      </p>
      <Button to={"/products/accessories"} text={t("accessoryContainer.buttonText")} />

      {/* Horizontal Divider */}
      <div
        className="w-full max-h-[20vh] pt-24 pb-24 flex justify-center"
        style={{ backgroundColor: colors.pastelCream }}
      >
        <hr
          className="w-[23%] sm:w-[15%] md:w-[15%] lg:w-[10%] h-0.5 border-t-0 opacity-100 dark:opacity-80"
          style={{ backgroundColor: colors.darkBrown }}
        />
      </div>
    </div>
  );
};

export default AccessoryContainer;
